import React, { useState, useEffect } from "react";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../firebase";

export default function ManageAgentForm({ agent, onClose, onAgentUpdated }) {
  const [form, setForm] = useState({
    id: agent.id,
    username: agent.username || "",
    password: agent.password || "",
    role: agent.role || "agent",
  });

  // Fetch latest agent info from Firestore
  useEffect(() => {
    const fetchAgent = async () => {
      try {
        const agentRef = doc(db, "agents", agent.id);
        const agentSnap = await getDoc(agentRef);
        if (agentSnap.exists()) {
          setForm((prev) => ({
            ...prev,
            ...agentSnap.data(),
          }));
        }
      } catch (err) {
        console.error("Error fetching agent:", err);
      }
    };

    fetchAgent();
  }, [agent.id]);

  const handleChange = (field, value) => {
    setForm({ ...form, [field]: value });
  };

  const handleSave = async () => {
    try {
      const docRef = doc(db, "agents", form.id);
      const updatedData = {
        username: form.username,
        password: form.password,
        role: form.role,
      };

      await updateDoc(docRef, updatedData);
      onAgentUpdated({ ...form }); // Update parent list
    } catch (error) {
      alert("Error updating agent.");
      console.error(error);
    }
  };

  return (
    <div style={panelStyle}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <h3>Manage Agent: {form.username}</h3>
        <button onClick={onClose} style={{ fontSize: "1.2rem", background: "none", border: "none", cursor: "pointer" }}>
          ✕
        </button>
      </div>

      <p style={{ color: "#6b7280", marginBottom: "1rem" }}>
        Update agent credentials and details.
      </p>

      <label>Agent ID</label>
      <input value={form.id} disabled style={inputStyle} />

      <label>Username</label>
      <input
        value={form.username}
        onChange={(e) => handleChange("username", e.target.value)}
        style={inputStyle}
      />

      <label>Password</label>
      <input
        type="text"
        value={form.password}
        onChange={(e) => handleChange("password", e.target.value)}
        style={inputStyle}
      />

      <label>Role</label>
      <input value={form.role} disabled style={{ ...inputStyle, backgroundColor: "#f3f4f6", cursor: "not-allowed" }} />

      <hr style={{ margin: "1.5rem 0" }} />

      <div style={{ marginTop: "2rem", display: "flex", justifyContent: "space-between" }}>
        <button onClick={onClose} style={cancelBtn}>
          Cancel
        </button>
        <button onClick={handleSave} style={saveBtn}>
          Save Agent Changes
        </button>
      </div>
    </div>
  );
}

// Styles
const panelStyle = {
  position: "fixed",
  top: 0,
  right: 0,
  width: "480px",
  height: "100%",
  background: "#fff",
  boxShadow: "-2px 0 8px rgba(0,0,0,0.1)",
  padding: "2rem",
  overflowY: "auto",
  zIndex: 1000,
};

const inputStyle = {
  width: "100%",
  padding: "0.6rem",
  marginBottom: "1rem",
  borderRadius: "6px",
  border: "1px solid #ccc",
};

const cancelBtn = {
  backgroundColor: "#e5e7eb",
  color: "#374151",
  padding: "0.7rem 1.4rem",
  borderRadius: "4px",
  border: "none",
  cursor: "pointer",
};

const saveBtn = {
  backgroundColor: "#1e40af",
  color: "white",
  padding: "0.7rem 1.4rem",
  borderRadius: "4px",
  border: "none",
  cursor: "pointer",
};
